module.exports = __webpack_public_path__ + "img/IMG_1149_L_Black_MockedUp.df56a321.jpg";